export default __webpack_public_path__ + "static/media/taste.8b3f1df5.svg";